/**
 * Utilitários de Data
 * Funções para manipulação de datas
 */

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export const DEFAULT_PERIODS = {
  DASHBOARD: 30,
  CLIENTS: 7,
  PROFILE: 30
};

/** Converte data string YYYY-MM-DD para objeto Date (evita problemas de timezone) */
export function parseDate(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

/** Converte string ou Date para Date object */
function toDateObject(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string' && ISO_DATE_REGEX.test(value)) {
    return parseDate(value);
  }
  return new Date(value);
}

/** Formata data para string YYYY-MM-DD */
export function formatDateISO(date) {
  if (typeof date === 'string' && ISO_DATE_REGEX.test(date)) {
    return date;
  }
  const d = toDateObject(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Gera array de datas no formato YYYY-MM-DD */
export function generateDateRange(startDate, endDate) {
  const dates = [];
  const current = toDateObject(startDate);
  const end = toDateObject(endDate);

  while (current <= end) {
    dates.push(formatDateISO(current));
    current.setDate(current.getDate() + 1);
  }

  return dates;
}

/** Retorna data de N dias atrás no formato YYYY-MM-DD */
export function getDaysAgo(days) {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return formatDateISO(date);
}
